
































































































































import { PropType } from 'vue';
import moment from 'moment';
import InventoryAdvancePaymentApproverList from './InventoryAdvancePaymentApproverList.vue';
import { mapActions } from 'vuex';

import {
  IInventoryAdvancePayment,
  IInventoryAdvancePaymentAttachment,
  IUserData
} from '@/models';
import { ISystemError } from '@/models/error/error.types';
import { User } from '@vue-altoleap-libraries/vue-altoleap-accounts-lib/types/model/userData';
import { createFile, setErrorFromAxiosError } from '@/utils/helpers';
import { ErrorManager } from '@/models/error';

import snackbar from '@/mixins/snackbar';
import mixins from '@/utils/mixins';
import auth from '@/mixins/auth';

import ErrorAlert from '../common/ErrorAlert.vue';
import InventoryAdvancePaymentAPSpecialistListMenu from './InventoryAdvancePaymentAPSpecialistListMenu.vue';
import InventoryAdvancePaymentFinanceManagersListMenu from './InventoryAdvancePaymentFinanceManagersListMenu.vue';
import InventoryAdvancePaymentDetailDrawerOwnerSelector from './InventoryAdvancePaymentDetailDrawerOwnerSelector.vue';
import InventoryAdvancePaymentStatusDisplay from '@/components/requisition-common/InventoryAdvancePaymentStatusDisplay.vue';
import InventoryAdvancePaymentAttachmentsList from './InventoryAdvancePaymentAttachmentsList.vue';

export default mixins(auth, snackbar).extend({
  components: {
    InventoryAdvancePaymentApproverList,
    InventoryAdvancePaymentAPSpecialistListMenu,
    InventoryAdvancePaymentFinanceManagersListMenu,
    InventoryAdvancePaymentDetailDrawerOwnerSelector,
    ErrorAlert,
    InventoryAdvancePaymentStatusDisplay,
    InventoryAdvancePaymentAttachmentsList
  },
  name: 'InventoryAdvancePaymentDetailDrawer',

  props: {
    inventoryAdvancePayment: {
      type: Object as PropType<IInventoryAdvancePayment>,
      required: true
    }
  },

  data: () => ({
    mini: true,
    drawer: true,

    errorMessage: '',
    detailErrorMessage: '',

    deleteAttachmentDialog: false,

    attachmentError: null as ISystemError | null
  }),

  computed: {
    authProvider(): any {
      return this.$altoleapAccounts.authProvider;
    },

    currentUser(): User {
      return this.authProvider.getCurrentUser;
    },

    isUserInventoryAdvancePaymentOwner(): boolean {
      return (
        this.authProvider.getCurrentUser.id ==
        (this.inventoryAdvancePayment.owner as IUserData).id!
      );
    },

    canAssignAPSpecialist(): boolean {
      return !!(
        this.inventoryAdvancePayment.ap_specialist &&
        this.userHasPermissions(['payment_requisitions.assign_ap_specialist'])
      );
    },

    canAssignFinanceManager(): boolean {
      return !!(
        this.inventoryAdvancePayment.finance_manager &&
        this.userHasPermissions(['payment_requisitions.assign_finance_manager'])
      );
    }
  },

  methods: {
    moment,

    ...mapActions({
      addInventoryAdvancePaymentComment:
        'inventoryAdvancePayment/updateInventoryAdvancePaymentComment',
      deleteInventoryAdvancePaymentAttachment:
        'inventoryAdvancePayment/deleteInventoryAdvancePaymentAttachment'
    }),

    clearAllErrors() {
      this.errorMessage = '';
      this.detailErrorMessage = '';
      this.attachmentError = null;
    },

    downloadAttachment(attachment: IInventoryAdvancePaymentAttachment) {
      this.clearAllErrors();
      this.$services.fileLoader
        .downloadFile(attachment.file as string)
        .then(data => {
          createFile(data, attachment.filename!);
        })
        .then(() => {
          this.createSnack({
            color: 'success darken-1',
            type: 'download',
            right: true,
            useBtn: false,
            msg: `Downloaded file: '${attachment.filename}'`,
            btnText: 'Close'
          });
        })
        .catch(error => {
          this.errorMessage = ErrorManager.extractApiError(error);

          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
        });
    },

    closeDeleteAttachmentDialog() {
      this.deleteAttachmentDialog = false;
    },

    removeAttachment(attachment: IInventoryAdvancePaymentAttachment) {
      this.clearAllErrors();
      this.deleteInventoryAdvancePaymentAttachment({
        inventoryAdvancePaymentId: this.inventoryAdvancePayment?.id,
        attachmentId: attachment.id
      })
        .then(() => {
          this.inventoryAdvancePayment.detachFile(attachment.file as File);
          this.createSnack({
            color: 'success darken-1',
            type: 'download',
            right: true,
            useBtn: false,
            msg: 'Sucessfully removed attachment',
            btnText: 'Close'
          });
        })
        .catch(error => {
          this.attachmentError = setErrorFromAxiosError(error);
        });
    }
  }
});
